import { render, staticRenderFns } from "./DetailsSignrequestButton.vue?vue&type=template&id=f87a8874&scoped=true"
import script from "./DetailsSignrequestButton.vue?vue&type=script&lang=ts"
export * from "./DetailsSignrequestButton.vue?vue&type=script&lang=ts"
import style0 from "./DetailsSignrequestButton.vue?vue&type=style&index=0&id=f87a8874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87a8874",
  null
  
)

export default component.exports